import * as React from "react";
import { observable, computed, action } from "mobx";
import { observer, inject } from "mobx-react";
import { Strings } from "../Stores/StringsStore";
import * as UiStore from "../States/AreaUiInfo";


@inject('areaUiInfo')
@observer
export class AreaSplitter extends React.Component<UiStore.IAreaUiInfo, {}> {

	@action handleMouseDown = (event: React.DragEvent<HTMLDivElement>) => {
		if (!this.props.areaUiInfo.isCollapsed) {
			event.preventDefault();
			event.stopPropagation();
			this.props.areaUiInfo.dragStart(event.pageX);
		}
	}

	@action handleTouchStart = (event: React.TouchEvent<HTMLDivElement>) => {
		if (!this.props.areaUiInfo.isCollapsed && event.touches.length > 0) {
			event.preventDefault();
			event.stopPropagation();
			this.props.areaUiInfo.dragStart(event.touches.item(0).pageX);
		}
	}

	@action handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
		if (this.props.areaUiInfo.isCollapsed) {
			event.preventDefault();
			event.stopPropagation();
			this.props.areaUiInfo.isCollapsed = false;
		}
	}

	@computed get shadow(): JSX.Element {
		let dragging = this.props.areaUiInfo && this.props.areaUiInfo.isDragging;
		if (dragging) {
			let style: React.CSSProperties = { left: this.props.areaUiInfo.dragDelta };
			return <div className="grid-splitter-drag" style={style} />
		}
		else {
			return null;
		}
	}

	render() {
		return <div className="grid-splitter"
			onMouseDown={this.handleMouseDown}
			onTouchStart={this.handleTouchStart}
			onClick={this.handleClick}>
			<span></span>
			{this.shadow}
		</div>;
	}
}
